<template>
  <DBox
    :id="'cmp-accounting-costs-cost_sidewindow-cost_lines'"
    :addButton="false"
    :addLink="true"
    @addClick="onAddClick"
    :addLinkLabel="`${$t('add_new')} ${$t('costlines')}`"
  >
    <NTable
      :headers="headers"
      :items="list"
      :config="tableConfig"
      :id="'accounting-costs-cost_sidewindow-cost_lines dbox1'"
      :showNoItems="false"
    >
      <template v-slot:item="{ item, tdcon }">
        <tr>
          <td v-bind="tdcon('option')">
            <TextField2
              class="dbox1"
              :id="'text'"
              :showLabel="false"
              :value="item['text']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td v-bind="tdcon('net_amount')">
            <TextField2
              class="dbox1"
              :id="'price'"
              :showLabel="false"
              :ta="'right'"
              :value="item['price']"
              @blur="(e) => onTextFieldValueChange(e, item)"
            />
          </td>
          <td  v-if="vat_handling == 1 || vat_handling == 2" v-bind="tdcon('vat_amount')">
            <Dropdown2
              class="dbox1 vat_amount"
              :ta="'right'"
              :showLabel="false"
              :options="vatRatesTV"
              :selected="vatRatesTV.find((v) => v.value == item.vat_type)"
              :placeholder="$t('vat_type')"
              v-on:selectedChange="(e) => onVatTypechange(item, e)"
              :bb="'0px'"
              lw="105px"
            >
            </Dropdown2>
          </td>
          <td v-bind="tdcon('status')">
            <img
              src="static/icons/delete.svg"
              @click.stop="(e) => deleteCost(item)"
              class="dt-icon v5 s2"
              alt
            />
          </td>
        </tr>
      </template>
    </NTable>
  </DBox>
</template>

<script>
import { confirmDelete } from "../../../../dt-plugins/confirmation/confirmation-common";
import NTable from "@/plugins/datatable/datatable";
import { AccountingStoreNamespace as storeNS } from "../../store";
import { EventHooks } from "../../../../plugins/text-field";
import { createNTableConfig } from "../../../../plugins/datatable";
import { CostsService } from "../../services/costs.service";
import { createTableHeader } from "../../../../plugins/datatable";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { costsActions } from "../../store/costs/actions";
export default {
  components: {
    NTable,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
      selectedStatus: null,
    };
  },
  computed: {
    headers: function () {
      return this.vat_handling == 1 || this.vat_handling == 2
        ? [
            createTableHeader("cost_line", { f: 0.65 }),
            createTableHeader("net_amount", {
              mw: 300,
              text: this.$t('net_amount'),
              ta: "right",
            }),
            createTableHeader("vat_amount", { mw: 120, ta: "right" }),
            createTableHeader("status", { text: false, mw: 30 }),
          ]
        : [
            createTableHeader("costline", { f: 0.65 }),
            createTableHeader("net_amount", {
              mw: 300,
              text: this.$t('net_amount'),
              ta: "right",
            }),
            // createTableHeader("vat_amount", { mw: 80, ta: "right" }),
            createTableHeader("status", { text: false, mw: 30 }),
          ];
    },
    list: function () {
      return this.selectedCostsDetails?.invoicelines || [];
    },
    vatRatesTV: function () {
      return this.selectedCostsDetails.vatRatesTV;
    },
    vat_handling: function () {
      return this.selectedCostsDetails?.invoice?.vat_handling;
    },
  },
  methods: {
    ...mapActionObject(storeNS, costsActions),
    onTextFieldValueChange: function ({ name, value }, item) {
      this.$emit("changed", {
        name,
        value,
        kVal: item.invoiceline_id,
        table: "invoicelines",
        item:item
      });
      
    },
    onVatTypechange: function (item, value) {
      item.vat_type=value.value;
      this.$emit("changed", {
        name: "vat_type",
        value: value.value,
        kVal: item.invoiceline_id,
        table: "invoicelines",
        item:item
      });
      
    },

    onAddClick: function () {
      CostsService.costInvoicelinesAdd(
        this.selectedCostsDetails?.invoice?.invoice_id
      ).then((res) => {
        const invoicelines = res.data.invoicelines;
        this[ActionTypes.AccountingCostLines.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          invoicelines: invoicelines || [],
        });
      });
    },
    onRelationTextBoxBlur: function (e, item) {
      const { id, value } = e.target;
      CostsService.modify_invoicelines(item.invoiceline_id, id, value);
    },
    deleteCost: async function (item) {
      const confirmationResult = await confirmDelete(
        "costLines",
        item.royalty_account_name
      );
      if (confirmationResult === "OK") {
        const res = await CostsService.costInvoicelinesDelete(
          this.selectedCostsDetails?.invoice?.invoice_id,
          item.invoiceline_id
        );
        const invoicelines = this.selectedCostsDetails.invoicelines.filter(
          (b) => b.invoiceline_id !== item.invoiceline_id
        );
        this[ActionTypes.AccountingCostLines.SET.ALL]({
          invoice_id: this.selectedCostsDetails?.invoice?.invoice_id,
          invoicelines: invoicelines || [],
        });
      }
    },
    // deleteCost(item) {
    //   this.$emit("delete", item);
    // },
    onClickAddCostlinesAdd() {
      this.$emit("addNew");
    },
  },
};
</script>


<style lang="scss">
.cmp-accounting-costs-cost_sidewindow-cost_lines {
  .vat_amount {
    .dropdown--main__text {
      text-align: right;
      justify-content: flex-end;
      padding-right: 5px;
    }
  }
}
</style>
